import { Select } from "antd";
import classNames from "classnames";
import { get, isEmpty, isObject } from "lodash";
import { useQuery } from "shared/hooks/useApi";
import Label from "../../Label";

const Async = ({
  label: selectLabel,
  node,
  errors,
  icon,
  labels,
  onChange = () => {},
  onSearch = () => {},
  touched,
  required,
  filter,
  optionFilterProp = "label",
  ...rest
}) => {
  const {
    query,
    variables,
    accessors: { root, label = "name", value = "id" },
  } = node;
  const getLabel = (item) => {
    if (!isEmpty(labels)) return labels[get(item, label)];
    if (isObject(label))
      return get(label, "keys", [])
        .map((key) => {
          const [principal, alt] = key.split(get(label, "separator", "-"));
          return get(item, principal) || get(item, alt);
        })
        .filter((value) => value)
        .join(get(label, "separator", "-"));
    return get(item, label);
  };
  const { data, loading } = useQuery(query, { variables });

  const rootItems = get(data, root) ?? [];

  const items = rootItems.map((item) => ({
    label: getLabel(item),
    value: get(item, value).toString(),
  }));

  return (
    <div className={classNames("select__lmf", { __error: touched && errors })}>
      <Label label={selectLabel} icon={icon} required={required} />
      <div className={`select__lmf--field`}>
        <Select
          size="large"
          className={classNames({ "disable--input": rest.disabled })}
          loading={loading}
          onChange={(selectedValue) => {
            return onChange(
              selectedValue,
              rootItems.find((item) => get(item, value) === selectedValue),
            );
          }}
          showSearch
          optionFilterProp={optionFilterProp}
          onSearch={onSearch}
          options={filter ? items.filter(filter) : items}
          {...rest}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

export default Async;
